
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Checklist from 'vux/src/components/checklist/index.vue'

import { zdsCategory } from './../../config/env'
import { getOrderDetail, GetPickItem, GetPickList, PutBindPickDisk } from '@/service/index'
const AuditStatus = ['未审核', '已审核']
export default {
data () {
return {
zdsCategory: zdsCategory,
Detail: {},
tabCur: 0,
PickList: [],
selectItem: '',

isShow: false,
radioValue: [],
curPanOid: '',
curOid: '',
curNumber: ''
}
},
components: {
Tab, TabItem, Swiper, SwiperItem, Checklist
},
created () {
this.getOrderDetail()

},
mounted () {
window.scrollTo(0,0);
},
watch: {
'$route': function (to, from) {

}
},
methods: {
change (val, label) {
console.log('change', val, label)
this.curNumber = label[0]
this.curOid = val[0]
},
SelectNomber(item){
if(this.PickList.length){
this.isShow = true
this.curPanOid = item.Oid
}else{
this.showToast('无其他可用挑货单!')
}

},
AlCancek(){
this.isShow = false
},
AlEnter(){
if(!this.curNumber||!this.curOid){
this.showToast('请选择单据编号!')
return
}
PutBindPickDisk({
Oid: this.curPanOid,
PickListId: this.curOid
}, result => {
console.log(JSON.parse(result.data));
let data = JSON.parse(result.data)
if (result.code === '1' && data.IsSuccess) {
this.showToast('切换成功!')
this.getOrderDetail();
}else{
this.showToast('切换失败! Err:'+data.Msg)
}
this.isShow = false
});
},
getOrderDetail () {
let vm = this
GetPickItem(this.$route.params.id, (result) => {
if (result.code === '1') {
vm.Detail = JSON.parse(result.data)

console.log(JSON.parse(JSON.stringify(vm.Detail)))
}
this.GetPickList();
})
},
swiperChange(e){
this.tabCur = e
},
SelectNo(item){
console.log(item)
console.log(this.selectItem)
if(item&&this.selectItem){
this.BindPan(this.selectItem,item)
}

},

BindPan(selectItem,item){

let curNumber = selectItem.split('@')[1]
let curOid = selectItem.split('@')[0]
console.log(item.Oid,curNumber)
if(!curNumber||!item.Oid){
this.showToast('请选择单据编号!')
return
}
this.showConfirm(
`<p>挑货盘：${item.Number}</p><p style="color:#000;">切换至</p><p>挑货单：${curNumber}</p>`, null,
() => {

PutBindPickDisk({
Oid: item.Oid,
PickListId: curOid
}, result => {
console.log(JSON.parse(result.data));
let data = JSON.parse(result.data)
if (result.code === '1' && data.IsSuccess) {
this.showToast('切换成功!')
this.getOrderDetail();
}else{
this.showToast('切换失败! Err:'+data.Msg)
}
});
}
)
},
GetPickList() {
let pData = {
pageNum: 0,
pageSize: 9999
};
GetPickList(pData, result => {
if (result.code === '1') {
let ls = JSON.parse(result.data);
console.log(ls)
if(ls.TotalCount == 0){

}else{
this.PickList = []
for (let item of ls.List) {


if(!item.IsLocked && item.Number!=this.Detail.Number){
item = JSON.parse(JSON.stringify(item))
item.edit = false


this.PickList.push({key: item.Oid,value: item.Number});

}
}
}
}
if(result.msg == '由于网络不稳定或长时间未操作，请重新登录！'){

this.$router.push({
path: '/login',
query: { redirect: this.$route.fullPath } ,
});
}
});
},
}
}



// WEBPACK FOOTER //
// ./src/page/picklist/detail.vue